import { setFarmerVisaFlowData } from 'redux/actionCreators/farmerVisaFlow'
import Actions from 'redux/actions'

export type State = {
  acknowledge: boolean
  occupationId: number
  nationalityId: number
  visaIssuePlaceId: number
  creditId: string
}

const initialState: State = {
  acknowledge: false,
  occupationId: 0,
  nationalityId: 0,
  visaIssuePlaceId: 0,
  creditId: '',
}

export default (state: State = initialState, action: ReturnType<typeof setFarmerVisaFlowData>) => {
  switch (action.type) {
    case Actions.SET_FARMER_VISA_FLOW_DATA:
      return {
        ...state,
        ...action.payload.data,
      }
    default:
      return state
  }
}
